module.exports = __webpack_public_path__ + "static/media/bg_row.27afc1a3.png";